import angular from 'angular';

import swoaNwfContributionAbacusExportComponent from './nwf-abacus-export.component';

export default angular
  .module('swoa.nwf-contribution.abacus', [
    swoaNwfContributionAbacusExportComponent,
  ])
  .name;
